import { render, staticRenderFns } from "./CountryBtns.vue?vue&type=template&id=1d162776&"
import script from "./CountryBtns.vue?vue&type=script&lang=js&"
export * from "./CountryBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports